module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"nHours":"{n} hour | {n} hours","runningTime":"Running Time"},"de":{"nHours":"{n} Stunde | {n} Stunden","runningTime":"Betriebsstunden"},"fr":{"nHours":"{n} heure | {n} heures","runningTime":"Temps de fonctionnement"},"it":{"nHours":"{n} ora | {n} ore","runningTime":"Tempo di Esecuzione"}}')
  delete Component.options._Ctor
}
